import React from "react"
import PropTypes from "prop-types"
import moment from 'moment'

class SentConnectItem extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      responded: false,
      accepted: false
    }

    this.renderTime = this.renderTime.bind(this)
  }

  renderTime() {
    let today = moment(new Date())
    let expDate = moment(this.props.req.created_at).add(7, 'days')
    let diffTime = expDate.diff(today, 'hours')
    let days = Math.trunc(diffTime/24)
    let hours = diffTime-(days*24)
    return(`${days} DAY${days != 1 ? 'S' : ''} AND ${hours} HOUR${hours != 1 ? 'S' : ''}`)
  }

  render() {
    return(
      <div
        style={{
          width: 350,
          maxWidth: '100%',
          borderRadius: 10,
          margin: 'auto',
          marginBottom: 24,
          border: '1px solid #F2F2F2',
          padding: 15,
          paddingTop: 20,
        }}>
          <div style={{
            margin: 'auto',
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'column'
          }}>
            <div style={{
              margin: 'auto',
              borderRadius: 5,
              display: 'flex',
              justifyContent: 'space-between',
              flexDirection: 'row-reverse'
            }}>
              <button
                style={{textAlign: 'left', cursor: 'pointer'}}
                onClick={() => window.location.assign(`/profile/${this.props.req.requestee.slug}`)}>
                <img
                  style={{height: 50, width: 50, borderRadius: 100}}
                  src={(this.props.req.requestee.avatar_url === "medium/missing.png") ? this.props.missingImg : this.props.req.requestee.avatar_url}>
                  </img>
              </button>
              <div>
                <p style={{fontSize: 8, marginBottom: 10}}>EXPIRES IN {this.renderTime()}</p>
                <h5 style={{lineHeight: 1.5, letterSpacing: .3, fontWeight: 200}}>{this.props.req.msg}</h5>
              </div>
            </div>
          </div>
      </div>
    )
  }

}


const styles = {
  buttonSection: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    cursor: 'pointer'
  },
  img: {
    width: 50,
    height: 50,
    marginBottom: 10
  }
}

export default SentConnectItem;
